export default {"src":"/_next/static/media/block-fabric-hash.dc008cb7.svg","height":208,"width":208};